import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useUserStrategies } from '../../../context/UserStrategies';
import { useUrlQuery } from '../../../hooks/use-url-query';
import { logger } from '../../../helpers/logger';

const WalletConnectReturn = () => {
  const navigate = useNavigate();
  const query = useUrlQuery();
  const { draftStrategy } = useUserStrategies();

  useEffect(() => {
    const strategyId = sessionStorage.getItem('walletStrategyId');
    sessionStorage.removeItem('walletStrategyId');

    logger.log('WalletConnect', { account: query.get('account') });

    navigate(
      `/strategies/${
        !strategyId || draftStrategy?.id === strategyId ? '' : strategyId
      }`,
      {
        state: {
          account: query.get('account'),
          isCreateStrategyModalOpen: draftStrategy?.id === strategyId,
        },
      }
    );
  }, []);

  return <></>;
};

export default WalletConnectReturn;
